import { combineReducers } from 'redux';
import { authorizationApi } from './services/authorization/api';
import auth from "./services/authorization/slices"
import { graphqlApi } from './services/graphql/api';
import dashboardSlice from './services/graphql/slices/dashboard-slice';
import rubricSlice from './services/graphql/slices/rubric-slice';
import criteriaSlice from './services/graphql/slices/criteria-slice';
import globalAlertsSlice from './services/graphql/slices/global-alerts-slice';
import manageContentSlice from './services/graphql/slices/manage-applications-slice';

import demographicsSlice from './services/graphql/slices/applicant-detail-slices/demographics-slice';
import scoresSlice from './services/graphql/slices/applicant-detail-slices/test-scores-slice';
import collegePrepSlice from './services/graphql/slices/applicant-detail-slices/college-prep-slice';
import documentsSlice from './services/graphql/slices/applicant-detail-slices/documents-slice';
import exportsSlice from './services/graphql/slices/exports-slice';
import reviewNotes from './Applicant/slices/administrativeNotes';
import rubricValues from './Applicant/slices/rubricValues';
import searchSlice from './services/graphql/slices/search-slice';
import jobsSlice from './services/graphql/slices/jobs-slice';
import scholarsQueueSlice from './services/graphql/slices/scholars-queue-slice';

export default combineReducers({ 
    [authorizationApi.reducerPath]: authorizationApi.reducer,
    authentication: auth,
    [graphqlApi.reducerPath]: graphqlApi.reducer,
    dashboardSlice,
    rubricSlice,
    criteriaSlice,
    demographicsSlice,
    scoresSlice,
    collegePrepSlice,
    documentsSlice,
    exportsSlice,
    manageContentSlice,
    reviewNotes,
    globalAlertsSlice,
    rubricValues,
    searchSlice,
    jobsSlice,
    scholarsQueueSlice,
})